import React from "react";
import { Card, CardContent, Typography, Box, styled } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "8px",
  border: "1px solid #E5E7EB",
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    borderColor: "#3B82F6",
    boxShadow:
      "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    "& .icon-box": {
      backgroundColor: "#DBEAFE",
    },
    "& .chevron-icon": {
      color: "#3B82F6",
    },
  },
}));

const IconBox = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  backgroundColor: "#EFF6FF",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#3B82F6",
  transition: "background-color 0.3s ease",
}));

export function SchemaCard({ icon, title, description, onSelect }) {
  return (
    <StyledCard onClick={onSelect}>
      <CardContent sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <IconBox className="icon-box">{icon}</IconBox>
          <ChevronRight
            className="chevron-icon"
            style={{
              width: 20,
              height: 20,
              color: "#9CA3AF",
              transition: "color 0.3s ease",
            }}
          />
        </Box>

        <Typography
          variant="h6"
          sx={{ color: "#111827", mb: 1, fontSize: "16px", fontWeight: 600 }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#6B7280", fontSize: "14px", lineHeight: 1.5 }}
        >
          {description}
        </Typography>
      </CardContent>
    </StyledCard>
  );
}
